import React from 'react';
import clsx from 'classnames';

export default function GlowCard({ className = '', children, as: Tag = 'div', hover = true }) {
  return (
    <Tag
      className={clsx(
        'relative rounded-2xl bg-white/5 backdrop-blur border border-white/10 shadow-soft',
        'before:pointer-events-none before:absolute before:inset-0 before:rounded-2xl before:shadow-glow before:opacity-0',
        hover && 'transition-all duration-200 hover:scale-[1.015] hover:before:opacity-100',
        className
      )}
    >
      {children}
    </Tag>
  );
}

